"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _TypingIndicator = require("./TypingIndicator.styles");

var TypingIndicator = function TypingIndicator(_ref) {
  var className = _ref.className;
  return (0, _jsxRuntime.jsx)("div", {
    css: _TypingIndicator.styles.base,
    className: className,
    children: (0, _jsxRuntime.jsx)("span", {})
  });
};

TypingIndicator.propTypes = {
  className: _propTypes.string
};
TypingIndicator.defaultProps = {
  className: undefined
};
var _default = TypingIndicator;
exports["default"] = _default;
//# sourceMappingURL=TypingIndicator.js.map